import Vue from 'vue';
import productSearchService from '../../../../services/product/search';

export default {
  components: {
    VCard: require('../../../../components/card/card.vue'),
    VNoData: require('../../../../components/noData/noData.vue'),
    VPagination: require('../../../../components/paginationNew/paginationNew.vue'),
    VSelect: require('../../../../components/form/select/select.vue'),
  },

  data() {
    return {
      loading: true,
      saving: false,
      addingLine: false,
      savingLine: false,
      currentPage: 1,
      perPage: 50,
      agreement: { client: null, lines: [] },
      form: {
        name: '',
        valid_from: null,
        valid_to: null,
        is_active: true,
      },
      newLine: {
        product_id: null,
        min_qty_or_pack_qty: 1,
        discount_percent: null,
        discount_amount: null,
        comment: null,
      },
      productOptions: [],
      productSearchLoading: false,
      editingLineId: null,
      editingForm: {
        min_qty_or_pack_qty: 1,
        discount_percent: null,
        discount_amount: null,
        comment: null,
      },
      productSearchQuery: '',
      viewLineMode: 'info',
      viewLineModePrimary: 'primary',
      sortLine: 'productName|asc',
      sortLineIds: ['productName|asc', 'productName|desc', 'minQty|asc', 'minQty|desc'],
      showTableEditDialog: false,
      editingLineRow: null,
    };
  },

  computed: {
    agreementLines() {
      return Array.isArray(this.agreement.lines) ? this.agreement.lines : [];
    },
    filteredAgreementLines() {
      const q = (this.productSearchQuery || '').trim().toLowerCase();
      if (!q) return this.agreementLines;
      return this.agreementLines.filter((line) => {
        const name = (line.product && line.product.name) ? String(line.product.name).toLowerCase() : '';
        const number = (line.product && line.product.number) ? String(line.product.number).toLowerCase() : '';
        return name.indexOf(q) !== -1 || number.indexOf(q) !== -1;
      });
    },
    sortedFilteredAgreementLines() {
      const list = [...this.filteredAgreementLines];
      const [field, dir] = (this.sortLine || 'productName|asc').split('|');
      const mult = dir === 'desc' ? -1 : 1;
      list.sort((a, b) => {
        let va; let vb;
        if (field === 'productName') {
          va = ((a.product && a.product.name) ? a.product.name : '').toLowerCase();
          vb = ((b.product && b.product.name) ? b.product.name : '').toLowerCase();
        } else if (field === 'minQty') {
          va = a.min_qty_or_pack_qty != null ? Number(a.min_qty_or_pack_qty) : 0;
          vb = b.min_qty_or_pack_qty != null ? Number(b.min_qty_or_pack_qty) : 0;
        } else {
          va = ((a.product && a.product.name) ? a.product.name : '').toLowerCase();
          vb = ((b.product && b.product.name) ? b.product.name : '').toLowerCase();
        }
        if (va < vb) return -1 * mult;
        if (va > vb) return 1 * mult;
        return 0;
      });
      return list;
    },
    pagination() {
      const total = this.sortedFilteredAgreementLines.length;
      const limit = this.perPage;
      return {
        currentPage: this.currentPage,
        lastPage: Math.max(1, Math.ceil(total / limit)),
        limit,
        totalCount: total,
      };
    },
    paginatedAgreementLines() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.sortedFilteredAgreementLines.slice(start, start + this.perPage);
    },
    sortLineTypes() {
      const keys = {
        'productName|asc': 'pricingAgreements.sortProductNameAsc',
        'productName|desc': 'pricingAgreements.sortProductNameDesc',
        'minQty|asc': 'pricingAgreements.sortMinQtyAsc',
        'minQty|desc': 'pricingAgreements.sortMinQtyDesc',
      };
      return this.sortLineIds.map((id) => ({ id, name: this.$t(keys[id] || id) }));
    },
  },

  watch: {
    '$route.params.id': function (id) {
      if (id) this.fetch();
    },
    productSearchQuery() {
      this.currentPage = 1;
    },
    editingLineId(val) {
      if (val == null) {
        this.showTableEditDialog = false;
        this.editingLineRow = null;
      }
    },
  },

  mounted() {
    this.fetch();
  },

  methods: {
    isEditingLine(line) {
      if (this.editingLineId == null) return false;
      return Number(this.editingLineId) === Number(line.id);
    },

    fetch() {
      const id = this.$route.params.id;
      if (!id) return;
      this.loading = true;
      Vue.$http.get(`pricing_agreements/${id}`)
        .then(({ data }) => {
          let payload = (data && data.data !== undefined) ? data.data : data;
          if (payload && typeof payload === 'object' && payload.data !== undefined && payload.id === undefined) {
            payload = payload.data;
          }
          this.agreement = payload && typeof payload === 'object' ? { ...payload } : { client: null, lines: [] };
          if (!Array.isArray(this.agreement.lines)) {
            this.agreement.lines = [];
          }
          this.form.name = this.agreement.name;
          this.form.valid_from = this.agreement.valid_from;
          this.form.valid_to = this.agreement.valid_to;
          this.form.is_active = this.agreement.is_active;
          this.currentPage = 1;
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },

    update() {
      this.saving = true;
      Vue.$http.put(`pricing_agreements/${this.$route.params.id}`, this.form)
        .then(() => {
          this.$message({ message: this.$t('pricingAgreements.agreementUpdated'), type: 'success' });
          this.saving = false;
          this.fetch();
        })
        .catch(() => {
          this.saving = false;
          this.$message({ message: this.$t('pricingAgreements.errorUpdatingAgreement'), type: 'error' });
        });
    },

    remoteProductSearch(query) {
      this.productSearchLoading = true;
      productSearchService({ search: query || '', filter: 'active' })
        .then((products) => {
          this.productOptions = products || [];
          this.productSearchLoading = false;
        })
        .catch(() => { this.productSearchLoading = false; });
    },

    addLine() {
      if (!this.newLine.product_id || !this.newLine.min_qty_or_pack_qty) {
        this.$message({ message: this.$t('pricingAgreements.productAndMinQtyRequired'), type: 'warning' });
        return;
      }
      if (this.newLine.discount_percent == null && this.newLine.discount_amount == null) {
        this.$message({ message: this.$t('pricingAgreements.setDiscountOrAmount'), type: 'warning' });
        return;
      }
      this.addingLine = true;
      const payload = {
        product_id: this.newLine.product_id,
        min_qty_or_pack_qty: this.newLine.min_qty_or_pack_qty,
        discount_percent: this.newLine.discount_percent,
        discount_amount: this.newLine.discount_amount,
        comment: this.newLine.comment || null,
      };
      Vue.$http.post(`pricing_agreements/${this.$route.params.id}/lines`, payload)
        .then(() => {
          this.$message({ message: this.$t('pricingAgreements.productAdded'), type: 'success' });
          this.addingLine = false;
          this.newLine = { product_id: null, min_qty_or_pack_qty: 1, discount_percent: null, discount_amount: null, comment: null };
          this.productOptions = [];
          this.fetch();
        })
        .catch(() => {
          this.addingLine = false;
          this.$message({ message: this.$t('pricingAgreements.errorAddingProduct'), type: 'error' });
        });
    },

    startEditLine(line) {
      this.editingLineId = Number(line.id);
      this.editingLineRow = line;
      this.editingForm = {
        min_qty_or_pack_qty: line.min_qty_or_pack_qty,
        discount_percent: line.discount_percent,
        discount_amount: line.discount_amount,
        comment: line.comment || '',
      };
      if (this.viewLineMode === 'primary') {
        this.showTableEditDialog = true;
      }
    },

    cancelEditLine() {
      this.editingLineId = null;
      this.showTableEditDialog = false;
      this.editingLineRow = null;
    },

    closeTableEditDialog() {
      this.showTableEditDialog = false;
      this.cancelEditLine();
    },

    saveLine(line) {
      const minQty = this.editingForm.min_qty_or_pack_qty;
      if (!minQty || minQty < 1) {
        this.$message({ message: this.$t('pricingAgreements.minQtyAtLeast1'), type: 'warning' });
        return;
      }
      if (this.editingForm.discount_percent == null && this.editingForm.discount_amount == null) {
        this.$message({ message: this.$t('pricingAgreements.setDiscountOrAmount'), type: 'warning' });
        return;
      }
      let discountPercent = this.editingForm.discount_percent;
      let discountAmount = this.editingForm.discount_amount;
      if (discountPercent !== '' && discountPercent != null && discountAmount !== '' && discountAmount != null) {
        discountAmount = null;
      }
      this.savingLine = true;
      const payload = {
        min_qty_or_pack_qty: minQty,
        discount_percent: discountPercent === '' || discountPercent == null ? null : Number(discountPercent),
        discount_amount: discountAmount === '' || discountAmount == null ? null : Number(discountAmount),
        comment: this.editingForm.comment || null,
      };
      Vue.$http.put(`pricing_agreements/${this.$route.params.id}/lines/${line.id}`, payload)
        .then(({ data }) => {
          const updated = (data && data.data !== undefined) ? data.data : data;
          const idx = this.agreement.lines.findIndex((l) => Number(l.id) === Number(line.id));
          if (idx !== -1 && updated && typeof updated === 'object') {
            this.$set(this.agreement.lines, idx, { ...this.agreement.lines[idx], ...updated });
          } else {
            this.fetch();
          }
          this.$message({ message: this.$t('pricingAgreements.productUpdated'), type: 'success' });
          this.savingLine = false;
          this.editingLineId = null;
          this.showTableEditDialog = false;
          this.editingLineRow = null;
        })
        .catch(() => {
          this.savingLine = false;
          this.$message({ message: this.$t('pricingAgreements.errorUpdatingProduct'), type: 'error' });
        });
    },

    deleteLine(line) {
      this.$confirm(this.$t('pricingAgreements.deleteProductConfirm'), this.$t('pricingAgreements.confirm'), { type: 'warning' })
        .then(() => {
          Vue.$http.delete(`pricing_agreements/${this.$route.params.id}/lines/${line.id}`)
            .then(() => {
              this.$message({ message: this.$t('pricingAgreements.productRemoved'), type: 'success' });
              this.fetch();
            })
            .catch(() => this.$message({ message: this.$t('pricingAgreements.errorRemovingProduct'), type: 'error' }));
        })
        .catch(() => {});
    },

    onPageChange(page, limit) {
      this.currentPage = page;
      this.perPage = limit;
    },

    changeLineView(mode) {
      if (this.viewLineMode !== mode) {
        this.viewLineModePrimary = this.viewLineMode;
        this.viewLineMode = mode;
      }
    },

    onChangeLineSort(val) {
      this.sortLine = val;
      this.currentPage = 1;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/pricingAgreements/edit/edit.js